import React, { useContext } from 'react'
import styled from 'styled-components'
import Img from 'gatsby-image'
import { useStaticQuery, graphql, Link } from 'gatsby'
import StoreContext from '~/context/StoreContext'
import '~/components/carousel.css'
// import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { Carousel } from 'react-responsive-carousel'

const SalePreviewGrid = () => {
  const { store: { checkout } } = useContext(StoreContext)
  const { allShopifyProduct } = useStaticQuery(
    graphql`
      query {
        allShopifyProduct(
          filter: {variants: {elemMatch: {availableForSale: {eq: true}}}}
          sort: {
            fields: [createdAt]
            order: ASC
          }
        ) {
          edges {
            node {
              id
              handle
              createdAt
              images {
                id
                originalSrc
                localFile {
                  childImageSharp {
                    fluid(maxWidth: 320) {
                      ...GatsbyImageSharpFluid_withWebp_tracedSVG
                    }
                  }
                }
              }
              variants {
                price
              }
            }
          }
        }
      }
    `
  )
  return (
    <>
      <SalePreview style={{ background: 'rgba(213,97,78,0.5)' }}>
        <h1 className='title'>Aktionen</h1>
        <p className='subtitle'>Für dich vergünstigt
        </p>

        <Carousel width='100%' showThumbs={false} showArrows={true} showStatus={false}  showIndicators={true}>
          {allShopifyProduct.edges
            ? allShopifyProduct.edges.map(({ node: { id, handle, images: [firstImage], variants: [firstVariant] } }) => (

              <Product key={id}>
                <Link to={`/product/${handle}/`}>
                  {firstImage && firstImage.localFile &&
                    (<Zoom>
                      <div style={{ margin: '0 auto' }}>
                        <Image
                          fluid={firstImage.localFile.childImageSharp.fluid}
                          alt={handle}

                        />
                      </div>
                    </Zoom>
                    )}

                </Link>
              </Product>

            ))
            : <p>Keine Produkte gefunden! Versuche die Seite neu zu laden!</p>}
        </Carousel>
      </SalePreview>
    </>
  )
}

export default SalePreviewGrid

const SalePreview = styled.div`
  margin: 10px auto;
  height: 500px;
  width: auto;
  max-width: 500px;
  min-width: 300px;
  box-shadow: 0 4px 15px 5px rgba(0,0,0,.25);
  padding: 64px;
  &:hover{
    box-shadow: 0 4px 15px 5px rgba(0,0,0,.8);
  }
`

const Product = styled.div`
  position: relative;
  display: flex;
  min-height: 100%;
  flex-direction: column;
  border-radius: 3px;
  box-shadow: 0 0 10px rgba(0,0,0,.1);
  @media(min-width: 779px){
    .detailsAndBuy{
      display: none;
      position: absolute;
      bottom: 0;
      right: 0;
      border: none;
      font-size: 1.4rem;
      transform: translate(100%, 100%);
      transition: all 0.2s linear;
    }
    &:hover{
      .detailsAndBuy{
        display: block;
        transform: translate(0,0);

      }
    }
  }
  @media(max-width: 779px){
    .detailsAndBuy{
      display: block;
      position: absolute;
      bottom: 0;
      right: 0;
      border: none;
      font-size: 1.4rem;
    }
  }
`

const Zoom = styled.div`
  overflow: hidden;
  height: 300px;
`

const Image = styled(Img)`
  max-width: 100%;
  height: 300px;
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  margin-bottom: 1.45rem;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.15);
  transition: transform .5s ease;
  &:hover{
    transform: scale(1.1);
  }
`
